<template>
  <div>
    <!-- Page header -->
    <div class="flex items-center gap-3 mb-4">
      <span class="flex items-center justify-center w-10 h-10 rounded-xl bg-taxiye-100 text-taxiye-500">
        <span class="material-icons-round">commute</span>
      </span>
      <div>
        <h2 class="text-lg font-semibold text-gray-800">Edit Vehicle Type</h2>
        <p class="text-sm text-gray-500">Update this vehicle category.</p>
      </div>
    </div>
    <form @submit.prevent="update">
      <div class="flex flex-col gap-4 lg:flex-row">
        <!-- Fields -->
        <div class="flex-1 p-6 bg-white border border-gray-200 shadow-sm rounded-2xl">
          <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Vehicle Type Name</span>
              <input
                v-model="vehicleType.name"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
                placeholder="Luxury"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">City</span>
              <input
                v-model="vehicleType.city"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
                placeholder="Addis Ababa"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Cost per KMs</span>
              <input
                v-model="vehicleType.pricePerKM"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
                placeholder="$"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Rent Price per Day</span>
              <input
                v-model="vehicleType.rentPerDay"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Rent Price per Hour</span>
              <input
                v-model="vehicleType.rentPerHour"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Price for Hard Workers</span>
              <input
                v-model="vehicleType.priceForHardWorkers"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Price for Medium Workers</span>
              <input
                v-model="vehicleType.priceForMediumWorkers"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Base Fare</span>
              <input
                v-model="vehicleType.baseFare"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Surge Price</span>
              <input
                v-model="vehicleType.surgePrice"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Rent Discount</span>
              <input
                v-model="vehicleType.rentDiscount"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Price per Minute</span>
              <input
                v-model="vehicleType.pricePerMin"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Number of Seats</span>
              <input
                v-model="vehicleType.numberOfSeats"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Pool Base Fare</span>
              <input
                v-model="vehicleType.poolBaseFare"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Pool Price per Minute</span>
              <input
                v-model="vehicleType.poolPricePerMin"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Pool Cost per KMs</span>
              <input
                v-model="vehicleType.poolPricePerKM"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Surge Base Fare</span>
              <input
                v-model="vehicleType.surgeBaseFare"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Surge Price per Minute</span>
              <input
                v-model="vehicleType.surgePricePerMin"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Surge Cost per KMs</span>
              <input
                v-model="vehicleType.surgePricePerKM"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              />
            </label>
            <label class="block">
              <span class="text-sm font-medium text-gray-600">Status</span>
              <select
                @change="setStatus"
                class="block w-full mt-1 text-sm border-gray-300 shadow-sm form-select rounded-xl focus:border-taxiye-300"
              >
                <option value="1" :selected="vehicleType.active">On</option>
                <option value="0" :selected="!vehicleType.active">Off</option>
              </select>
            </label>
          </div>
        </div>

        <!-- Photo -->
        <div class="w-full p-6 bg-white border border-gray-200 shadow-sm lg:w-80 rounded-2xl">
          <photo-uploader
            v-model="vehicleType.photo"
            label="Vehicle Type Image"
          />
        </div>
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-end gap-3 mt-4">
        <back-button></back-button>
        <button
          :disabled="busy"
          class="inline-flex items-center justify-center h-10 px-6 text-sm font-semibold text-white transition-colors duration-150 shadow-sm rounded-xl"
          :class="
            busy
              ? 'bg-taxiye-200 cursor-not-allowed'
              : 'bg-taxiye-500 hover:bg-taxiye-600'
          "
        >
          Save
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import PhotoUploader from "@/components/PhotoUploader.vue";
import BackButton from "@/components/BackButton.vue";

export default {
  components: {
    PhotoUploader,
    BackButton,
  },
  data() {
    return {
      busy: false,
      vehicleType: {
        photo: "",
        name: "",
        pricePerKM: 0,
        active: false,
        rentPerDay: 0,
        rentPerHour: 0,
        priceForHardWorkers: 0,
        priceForMediumWorkers: 0,
        baseFare: 0,
        surgePrice: 0,
        pricePerMin: 0,
        numberOfSeats: 0,
        poolBaseFare: 0,
        poolPricePerKM: 0,
        poolPricePerMin: 0,
      },
    };
  },
  created() {
    this.getVehicleType();
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    setStatus(e) {
      this.vehicleType.active = e.target.value === "1";
    },
    update() {
      this.busy = true;
      this.$misc
        .patch(`/vehicleTypes/${this.id}`, { ...this.vehicleType })
        .then(() => {
          this.$router.push("/vehicle-types");
          window.flash({
            type: "success",
            body: "Vehicle Type edited successfully!",
          });
        })
        .catch(err => console.log(err))
        .finally(() => (this.busy = false));
    },
    getVehicleType() {
      this.$misc
        .get(`vehicleTypes/${this.id}`)
        .then(response => (this.vehicleType = response.data))
        .catch(err => console.log(err));
    },
  },
};
</script>
